import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import animations from 'src/styles/animations';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, animations.pulse), helpers), {}, {
  flexBox: {
    display: 'flex',
    alignItems: 'center'
  },
  grid: {
    '& .MuiDataGrid-row:has(.finallBill) .MuiDataGrid-cell ': {
      padding: '8px 5px 32px 5px'
    },
    '& .MuiDataGrid-columnHeader:first-child': {
      '&:hover .MuiDataGrid-columnHeaderDraggableContainer': {
        backgroundColor: 'transparent'
      },
      '& button': {
        display: 'none'
      }
    },
    '& .MuiDataGrid-cell:first-of-type': {
      paddingLeft: '10px'
    },
    '& .MuiDataGrid-columnHeader:nth-of-type(1)': {
      paddingLeft: '17px'
    },
    '& .MuiDataGrid-columnHeader:last-child': {
      paddingRight: '10px',
      '& .MuiButton-root': {
        margin: 0
      }
    },
    '& .MuiDataGrid-cell:last-of-type': {
      paddingRight: '12px',
      justifyContent: 'center'
    },
    '& .MuiChip-root': {
      fontWeight: '600'
    }
  },
  tableContainer: {
    width: '100%'
  },
  rippleContainer: {
    width: '100%'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  disabledCell: {
    backgroundColor: palette.shades[200],
    '& .MuiButton-root': {
      backgroundColor: palette.shades[200],
      borderColor: palette.shades[300]
    }
  },
  disabledCellText: {
    color: palette.shades[500],
    padding: '10px 6px'
  },
  tooltipContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  moveOutChips: {
    marginLeft: '4px'
  },
  rightAlign: {
    textAlign: 'right'
  },
  accessWrapper: {
    padding: '4px !important',
    width: 'auto !important'
  },
  chipsWrapper: {
    '& .MuiTypography-root': {
      marginLeft: '10px'
    },
    '& .MuiChip-root': {
      width: '28px',
      height: '28px',
      '&.MuiChip-colorDefault': {
        borderColor: "".concat(palette.shades[200])
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1rem'
      }
    }
  },
  statusInfo: {
    display: 'flex'
  },
  billingOpt: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  lightTrigger: {
    backgroundColor: palette.shades[100],
    '& path': {
      fill: palette.shades[700]
    },
    '&:hover': {
      backgroundColor: palette.shades[100],
      '& path': {
        fill: palette.shades[800]
      }
    }
  },
  cellLeftAlign: {
    justifyContent: 'flex-start !important'
  },
  cellContent: {
    borderRadius: '2px',
    transition: "all ".concat(palette.transitions.short),
    width: '100%',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: palette.shades[300],
      cursor: 'pointer'
    }
  },
  toolboxWrapperHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  balanceCritical: {
    backgroundColor: palette.error.light,
    '&:after': {
      backgroundColor: palette.error.main,
      animation: '$pulse 1.4s infinite cubic-bezier(0.4, 0, 0.2, 1)'
    }
  },
  balanceOk: {
    backgroundColor: palette.success.light,
    '&:after': {
      backgroundColor: palette.success.main
    }
  },
  balanceDue: {
    backgroundColor: palette.warning.light,
    '&:after': {
      backgroundColor: palette.warning.main
    }
  },
  balanceDisabled: {
    backgroundColor: palette.shades[300],
    '&:after': {
      backgroundColor: palette.shades[500]
    }
  },
  successBlock: {
    '& .tooltip-header': {
      backgroundColor: palette.success.light,
      '& .MuiTypography-root': {
        color: palette.success.dark
      }
    },
    '& .MuiSvgIcon-root': {
      '& path': {
        fill: palette.success.main
      }
    }
  },
  residentLine: {
    display: 'flex',
    alignItems: 'center'
  },
  finallBillWrapper: {
    left: '0',
    right: '0',
    bottom: '1px',
    height: '24px',
    fontSize: '14px',
    lineHeight: '24px',
    textAlign: 'center',
    position: 'absolute',
    backgroundColor: palette.warning.light,
    '& b': {
      color: palette.primary.main,
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  },
  finallBillWrapperOverdue: {
    backgroundColor: palette.error.light
  },
  finallBillWrapperReady: {
    backgroundColor: palette.info.light
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      minWidth: '210px',
      maxWidth: '300px'
    }
  },
  tooltipContainer: {
    minWidth: '220px'
  }
}));
export default useStyles;